import Qrcode from 'qrcode.react'

function SignSuccess() {
  return (
    <div className='text-center'>
      <Qrcode className='mx-auto mt-20 mb-10' size={200} value={window.location.href} />
      <div className='text-3xl text-blue-600 mx-10 mb-2 leading-relaxed'>签到成功</div>
      <div className='text-2xl text-red-400 mx-10 leading-relaxed'>请勿关闭此签到页面</div>
      <div className='text-2xl text-red-400 mx-10 leading-relaxed'>凭该页面领取入会出入证</div>
    </div>
  )
}

export default SignSuccess
